'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  gallery: {
    wixInit: false,
    renderedItemsCount: 50,
    videoIndexPlay: -1,
    lastVideoPlayed: -1,
    isInView: true,
    documentHeight: _utils2.default.getScreenHeight()
  },
  fullscreen: {}
};